import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { 
    Box,
    Text,
    SimpleGrid,
    VStack,
    HStack,
} from "@chakra-ui/react";
import "../index.css"
import { Title, Word, Image, LightBg, ParentCard} from "./style";
import Card from '../../components/Card';
import Footer from "../../components/Footer";
import Navigation from "../../components/Navbar";
import APIConfig from "../../api/APIConfig";
import AuthService from "../../services/auth.service";

function recruitmentTime(string){
    return new Date(string).getMonth();
}

function publishDay(string){
    return new Date(string).getDate();
}


const DetailMitra = (props) => {
    const { id } = useParams();
    const { idPeserta } = useParams();
    const [mitra, setMitra] = useState([]);
    const [lowonganMitra, setLowonganMitra] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);

    let d = new Date().getDate();

    const getLowongan = async() => {
        const response = await APIConfig.get(`/v1/lowongan/${id}`);
        const result = await response.data;
        setMitra(result.mitra);
    
        const response2 = await APIConfig.get(`/v1/lowongan/mitra/${result.mitra.idMitra}`);
        const result2 = await response2.data;
        setLowonganMitra(result2);
    };

    useEffect(() => {
        getLowongan();
    }, []);

    useEffect(() => {
        const user = AuthService.getCurrentUser();

        if(user) {
            setCurrentUser(user);
        }
    }, []);

    return (
        <>
        <Navigation />
        <VStack pt={15} pl={20} align='stretch' fontFamily="Inter">
            <Text fontWeight={'700'} fontSize={"25px"}>Informasi Perusahaan</Text>
            <HStack fontSize={"13px"} color={'gray.500'} pb={3}>
                <Link to={`/lowongan/detail/${idPeserta}/${id}`}> Detail Lowongan </Link>
                <p> / </p>
                <Link to={`/mitra/detail/${id}`}> Informasi Mitra </Link>
            </HStack>
        </VStack>
        <HStack align="start" p={6} fontFamily='Inter'>
            <Image src={mitra.image}></Image>
            <VStack align='stretch' p={6}>
                <Title>{mitra.namaResmi}</Title>
                <br></br>
                <Word>{mitra.shortDesc}</Word>
                <br></br>
                <SimpleGrid columns={[3, null, 3]} spacing='40px' border={'1px solid #DADADA'} borderRadius={'5px'} padding={'50px'}>
                <Box height='100%'>
                    <Word style={{color: '#828282'}}>Kantor Pusat</Word>
                    <Word>{mitra.lokasiPusat}</Word>
                </Box>
                <Box height='100%'>
                    <Word style={{color: '#828282'}}>Situs</Word>
                    <Word>{mitra.website}</Word>
                </Box>
                <Box height='100%'>
                    <Word style={{color: '#828282'}}>Alamat</Word>
                    <Word>{mitra.alamat}</Word>
                </Box>
                <Box height='100%'>
                            <Text style={{color: '#828282'}}>Industri</Text>
                            {mitra.kategori === 0 ? (
                                        <Text>Startup</Text> 
                                    ) : (
                                        mitra.kategori === 1 ? (
                                        <Text>Global Company</Text>
                                    ) : (
                                        mitra.kategori === 2 ? (
                                        <Text>Multilaterals Organizations</Text>
                                    ) : (
                                        mitra.kategori === 3 ? (
                                        <Text>Non-profits Organizations</Text>
                                    ) : (
                                        <Text>Hospitals</Text>
                                ))))}
                </Box>
                <Box height='100%'>
                            <Text style={{color: '#828282'}}>Ukuran Perusahaan</Text>
                            {mitra.sizeMitra === 0 ? (
                                        <Text>1-10</Text> 
                                    ) : (
                                        mitra.sizeMitra === 1 ? (
                                        <Text>11-50</Text>
                                    ) : (
                                        mitra.sizeMitra === 2 ? (
                                        <Text>51-100</Text>
                                    ) : (
                                        mitra.sizeMitra === 3 ? (
                                        <Text>100-500</Text>
                                    ) : (
                                        mitra.sizeMitra === 4 ? (
                                            <Text>501-1000</Text>
                                    ) : (
                                        mitra.sizeMitra === 5 ? (
                                            <Text>1001-5000</Text>
                                    ) : (
                                        mitra.sizeMitra === 6 ? (
                                        <Text>5001-10000</Text>
                                    ) : (
                                        <Text>+10000</Text>
                                )))))))}
                        </Box>
                <Box height='100%'>
                    <Word style={{color: '#828282'}}>Tahun Berdiri</Word>
                    <Word>{mitra.tahunBerdiri}</Word>
                </Box>
                </SimpleGrid>
            </VStack>
        </HStack>

        <LightBg>
        <Text fontStyle="Inter" fontWeight={'700'} fontSize={"25px"}>Lowongan Magang</Text>
            <ParentCard>
                {lowonganMitra.map((data) => (
                <Link to={`/lowongan/detail/${idPeserta}/${data.idLowongan}`} 
                    style={{color:'#000000', margin: 'auto', textDecoration: 'none'}}>
                    <Card 
                        jabatan={data.proposal.namaPosisi}
                        perusahaan={mitra.namaResmi}
                        durasi={`${recruitmentTime(data.proposal.tanggalSelesai) - recruitmentTime(data.proposal.tanggalMulai)} bulan`}
                        lokasi={data.proposal.lokasi}
                        waktuPost={`${d - publishDay(data.waktuDipublish)} hari yang lalu`}
                        logo={mitra.image}
                        nominal={data.proposal.nominal}
                    />
                </Link>
                ))}
            </ParentCard>
        </LightBg>    
        <Footer/>
        </>
    );
}

export default DetailMitra;